import { SliderThumb, Typography } from '@mui/material';
import * as React from 'react';
import PropTypes from 'prop-types';

export default function ThumbComponent({ children, ownerState, 'data-index': dataIndex, ...other }) {
  const item = ownerState.marks[dataIndex];
  return (
    !!item && (
      <SliderThumb
        {...other}
        ownerState={ownerState}
        sx={{ filter: item.isInactive ? 'contrast(0.176) brightness(1.7)' : 'none' }}
      >
        {children}
        <Typography className="label">{item.orderLabel}</Typography>
        <Typography className={`tooltip ${item.isLoading ? 'top' : 'bottom'}`} sx={{ color: 'text.secondary' }}>
          {!item.isLoading ? item.date : null}{' '}
          <Typography className="order" component="span">
            {item.orderIdShort}
          </Typography>{' '}
          {item.isLoading ? item.date : null}
        </Typography>
      </SliderThumb>
    )
  );
}

ThumbComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  ownerState: PropTypes.shape({
    marks: PropTypes.arrayOf(
      PropTypes.shape({
        isInactive: PropTypes.bool,
        isLoading: PropTypes.bool,
        orderNum: PropTypes.number,
        orderLabel: PropTypes.number,
        orderNumLoading: PropTypes.number,
        orderNumDelivery: PropTypes.number,
        date: PropTypes.string,
        orderIdShort: PropTypes.string,
      }),
    ),
  }).isRequired,
  'data-index': PropTypes.number.isRequired,
};
